import { createAction, props } from '@ngrx/store';
import { Order, OrderDTO, OrdersFilters } from '../../commons/models/order';
import { Address } from '../../commons/models/address';
import { Customer } from '../../commons/models/customer';
import { ProductInOrder } from '../../commons/models/product-in-order';
import { Zones } from '../../commons/models/zone';
import { Product } from '../../commons/models/product';


export const loadOrders = createAction('[Order] Load Orders',props<{ page?: number, per_page?: number, order?:string, direction?: string, filters?: OrdersFilters, zoneIds?: Array<number>, statuses?: Array<number>, date?: string, customer_id?: number, deliveryman_id?: number, include_pick?: boolean, include_delivery?: boolean, with_sweets?: boolean, include_archived?: boolean, include?: string[] }>());
  
export const loadOrdersSuccess = createAction('[Order] Load Orders Success',props<{ orders: OrderDTO[], filters: OrdersFilters }>());

export const loadOrdersCompleted = createAction('[Orders] Load Orders Completed', props<{ orders: OrderDTO[], currentPage: number, total: number, perPage: number, order?: string, direction?: string, filters?: OrdersFilters, includes?: string[], zoneIds?: Array<number>, statuses?: Array<number>, date?: string, customer_id?: number, deliveryman_id?: number, include_pick?: boolean, include_delivery?: boolean, with_sweets?: boolean, include_archived?: boolean, include?: string[]}>());

export const loadOrdersFailure = createAction('[Order] Load Orders Failure',props<{ error: any }>());

export const saveOrder = createAction('[Order] Create Order',props<{ order: Order }>());

export const saveOrderFailed = createAction('[Orders] Save order failed', props<{ error: any }>());

export const showOrderDialog = createAction('[Orders] Show Order Dialog',props<{ title: string; message: string; order: OrderDTO }>());

export const editOrder = createAction('[Orders] Edit Order',props<{ order: Order, zones: Zones, products: Product }>());

export const orderDialogOpened = createAction('[Orders] Detail dialog opened', props<{ dialogId: string }>());

export const createOrderSuccess = createAction('[Order] Create Order Success',props<{ order: Order }>());

export const createOrdersSuccess = createAction( '[Orders] Create Order Success', props<{ order: OrderDTO }>())

export const closeOrdersDialog = createAction('[Orders] Close detail dialog');

export const createOrderFailure = createAction('[Order] Create Order Failure',props<{ error: any }>());
  
export const updateOrder = createAction('[Order] Update Order',props<{ order: Order }>());
  
export const updateOrderSuccess = createAction('[Order] Update Order Success',props<{ order: OrderDTO }>());
  
export const updateOrderFailure = createAction('[Order] Update Order Failure',props<{ error: any }>());
  
export const deleteOrder = createAction('[Order] Delete Order',props<{ orderId: number }>());

export const deleteOrderSuccess = createAction('[Order] Delete Order Success',props<{ orderId: number }>());

export const deleteOrderFailure = createAction('[Order] Delete Order Failure',props<{ error: any }>());
  
export const loadOrdersFailed = createAction('[Orders] Load Orders Failed', props<{ error: any }>());
